import React from 'react';

import { PreloaderPolygon } from '../../../../Preloader';

import styles from './preloader.module.scss';

export interface IShareButtonsPreloaderProps {}

export const ShareButtonsPreloader: React.FC<IShareButtonsPreloaderProps> = () => {
  const renderRow = (key: string) => {
    return (
      <div key={key} className={styles.row}>
        <PreloaderPolygon className={styles.item} style={{ width: 40, height: 40 }} />
        <PreloaderPolygon className={styles.item} style={{ width: 'calc(100% - 40px - 12px)', height: 20 }} />
      </div>
    );
  };
  return (
    <>
      {Array(7)
        .fill(null)
        .map((_, i) => {
          return renderRow(`row-${i}`);
        })}
    </>
  );
};
